<template>
    <div class="content">
        <section>
            <div class="content-box">
                <HeaderBg :title="'Number'" :sub_title="'Victory'" :desc="'Latest EUROPE LOTTO Lottery Draw Results'" />

                <div class="text-center">
                    <QuickCard v-for="result in results" :key="result.id"
                        :title="`${result.type.toUpperCase()} Quick Pick`" :redirect="`/${result.type}_result`"
                        :data="result" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { ref, onMounted } from "vue";
import api from '@/axios'
import { asApiArray } from '@/utils/apiData'
import QuickCard from "./components/QuickCard.vue";
import HeaderBg from "./components/HeaderBg.vue";

export default {
    name: "QuickPick",
    components: { QuickCard, HeaderBg },
    setup() {
        const results = ref([]);

        onMounted(async () => {
            try {
                const response = await api.get('/results/latest')
                results.value = asApiArray(response.data)

            } catch (error) {
                console.error('Error fetching results:', error)
            }

            // results.value = [
            //     {
            //         id: 145,
            //         type: "3d",
            //         first: "233",
            //         second: "142",
            //         third: "737",
            //         created_at: "2025-04-18 08:00:00",
            //         nextDrawTime: "2025-05-09 12:00:01",
            //         period: "4839"
            //     },
            //     {
            //         id: 147,
            //         type: "4d",
            //         first: "2587",
            //         second: "8865",
            //         third: "4030",
            //         created_at: "2025-05-02 12:00:01",
            //         nextDrawTime: "2025-05-09 12:00:01",
            //         period: "489"
            //     },
            //     {
            //         id: 146,
            //         type: "5d",
            //         first: "92164",
            //         second: "08792",
            //         third: "18039",
            //         created_at: "2025-05-02 12:00:01",
            //         nextDrawTime: "2025-05-10 14:00:01",
            //         period: "839"
            //     },
            // ];
        });

        return { results };
    },
};
</script>